import { accessRouteChain } from './access-route-chain.js';
import { routeRequirements } from './route-requirements.js';
/** Permissions a route's page reads beyond what it needs to open, its ancestors' included. */
export function routeLookups(route) {
    const required = new Set(routeRequirements(route));
    const lookups = accessRouteChain(route).flatMap((entry) => entry.lookups ?? []);
    return [...new Set(lookups)].filter((permission) => !required.has(permission));
}
//# sourceMappingURL=route-lookups.js.map